export default "__VITE_ASSET__rtyXN0eE__"